<ng-container *ngFor="let wave of waves; let i = index";>
  <app-grid [index]="waves.length - i" [wave]="wave">
  </app-grid>
</ng-container>